import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const PowerPointFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="8" width="48" height="48" rx="10" fill="#D24726" />
    <path
      fill="#FFFFFF"
      d="M22 20.4h10.4c5.4 0 8.8 3.1 8.8 7.7 0 4.7-3.5 7.8-8.9 7.8H27.4V44H22V20.4zm5.4 11.1h4.4c2.6 0 4.1-1.4 4.1-3.4s-1.5-3.3-4.1-3.3h-4.4v6.7z"
    />
  </g>,
  'PowerPointFileIcon',
);
